import React, {Component} from "react";
import Box from "@mui/material/Box";
import {CenterLoading, decodeTool} from "../App";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {CardContent, List, ListItem, ListItemButton, ListItemText, Pagination} from "@mui/material";
import {BottomSheet} from "../assets/bottom_sheet_mui/src/components/BottomSheet";
import * as PropTypes from "prop-types";
import * as Icons from '@mui/icons-material';
import ListItemIcon from "@mui/material/ListItemIcon";
import Container from "@mui/material/Container";


ListItemIcon.propTypes = {children: PropTypes.node};
export default class AnimeDate extends Component {

    componentDidMount() {
        document.getElementById("actionBar").style.display = "block";
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            page: 1,
            data: [],
            error: false,
            menuFav: false,
            menuID: '',
            menuWatchData: {},
        };
        this.prepare();
    }

    checkTheme = () => {
        if (localStorage.getItem("darkMode") == null) {
            return true;
        } else {
            if (localStorage.getItem("darkMode").includes("true")) {
                return true;
            } else {
                return false;
            }
        }
    }

    prepare = () => {
        fetch('https://app.sanime.net/function/h10.php?page=date').then((value) => {
            value.text().then((value) => {
                let JS = JSON.parse(value);
                this.setState({
                    data: JS,
                    loading: false
                });
            });
        }).catch((error) => {
            this.setState({
                loading: false,
                error: true
            });
        });
        window.react.setState({
            homeTitle: "مواعيد الأنمي"
        });
    }

    restartPage = () => {
        this.setState({
            loading: true,
            error: false
        });
        setTimeout(()=> {
            this.prepare();
        },500);
    }

    render() {
        if (this.state.loading) {
            return <CenterLoading/>
        } else {
            return <List>
                {
                    this.state.data.map((steps, index) => (
                        <div>
                            <ListItem style={{padding: '0px',width: "100%"}}>
                                <Card style={{width: "100%",margin: "6px"}}>
                                    <CardContent style={{padding: "3px"}}>
                                        <Typography style={{fontSize: '16px',textAlign: "center"}}>{steps.day}</Typography>
                                    </CardContent>
                                </Card>
                            </ListItem>
                            <ListItem style={{padding: '0px'}} key={steps.day}>
                                <Container disableGutters >
                                    <div className="scrollmenu" style={this.checkTheme() ? {backgroundColor: '#182128'} : {backgroundColor: '#efeeee'}}>
                                        {steps.list.map((step, index) => (
                                            <div key={step.name}>
                                                <Card style={{margin: "6px"}} sx={{ width: 112 }} >
                                                    <CardActionArea>
                                                        <CardMedia
                                                            component="img"
                                                            height="175"
                                                            image={step.image}
                                                            alt={step.name}
                                                        />
                                                        <Divider sx={{height: 1.2}} color={'#00b2ff'}/>
                                                        <Stack style={{paddingLeft: '4px',paddingBottom: '3px',paddingTop: '1px'}} spacing={0}>
                                                            <Typography style={{textOverflow: "ellipsis",overflow: "hidden",fontSize: '14px',whiteSpace: "nowrap"}}>{step.name}</Typography>
                                                            <Typography style={{textAlign: 'left',fontSize: '14px'}}>{step.ep}</Typography>
                                                        </Stack>
                                                    </CardActionArea>
                                                </Card>
                                            </div>
                                        ))}
                                    </div>
                                </Container>
                            </ListItem>
                        </div>
                    ))
                }
            </List>
        }
    }
}
